<div class="container-fluid">
  <h1 mat-dialog-title i18n>Edit Customer Import</h1>
  <div mat-dialog-content>
    <p i18n>Modify information as required.</p>
    <form #importForm="ngForm" (ngSubmit)="updateImport(importForm)">
      <div class="form-group row">
        <label for="businessName" class="col-sm-4 col-form-label">
          <span class="warning">* </span><span i18n>Business Name</span>
        </label>
        <div class="col-sm-8">
          <input name="customer_BusinessName" class="form-control"
                 matInput
                 required
                 [(ngModel)]="data.customer.customer_BusinessName" #customer_BusinessName="ngModel" />
          <div [hidden]="!importForm.submitted || customer_BusinessName.valid"
               class="alert alert-danger" i18n>Enter Business Name</div>
        </div>
      </div>
      <div class="form-group row">
        <label for="customer_Address1" class="col-sm-4 col-form-label" i18n>Address 1</label>
        <div class="col-sm-8">
          <input name="customer_Address1" class="form-control"
                 matInput
                 [(ngModel)]="data.customer.customer_Address1" #customer_Address1="ngModel" />
        </div>
      </div>
      <div class="form-group row">
        <label for="customer_Address2" class="col-sm-4 col-form-label" i18n>Address 2</label>
        <div class="col-sm-8">
          <input name="customer_Address2" class="form-control"
                 matInput
                 [(ngModel)]="data.customer.customer_Address2" #customer_Address2="ngModel" />
        </div>
      </div>
      <div class="form-group row">
        <label for="customer_City" class="col-sm-4 col-form-label" i18n>City</label>
        <div class="col-sm-8">
          <input name="customer_City" class="form-control"
                 matInput
                 [(ngModel)]="data.customer.customer_City" #customer_City="ngModel" />
        </div>
      </div>
      <div class="form-group row">
        <label for="customer_State" class="col-sm-4 col-form-label" i18n>State</label>
        <div class="col-sm-8">
          <input name="customer_State" class="form-control"
                 matInput
                 [(ngModel)]="data.customer.customer_State" #customer_State="ngModel" />
        </div>
      </div>
      <div class="form-group row">
        <label for="customer_Postal" class="col-sm-4 col-form-label" i18n>Zip</label>
        <div class="col-sm-8">
          <input name="customer_Postal" class="form-control"
                 matInput
                 [(ngModel)]="data.customer.customer_Postal" #customer_Postal="ngModel" />
        </div>
      </div>
      <div class="form-group row">
        <label for="contact_FirstName" class="col-sm-4 col-form-label" i18n>Contact First Name</label>
        <div class="col-sm-8">
          <input name="contact_FirstName" class="form-control"
                 matInput
                 [(ngModel)]="data.customer.contact_FirstName" #contact_FirstName="ngModel" />
        </div>
      </div>
      <div class="form-group row">
        <label for="contact_LastName" class="col-sm-4 col-form-label" i18n>Contact Last Name</label>
        <div class="col-sm-8">
          <input name="contact_LastName" class="form-control"
                 matInput
                 [(ngModel)]="data.customer.contact_LastName" #contact_LastName="ngModel" />
        </div>
      </div>
      <div class="form-group row">
        <label for="contact_Email" class="col-sm-4 col-form-label" i18n>Contact Email</label>
        <div class="col-sm-8">
          <input name="contact_Email" class="form-control"
                 matInput
                 [(ngModel)]="data.customer.contact_Email" #contact_Email="ngModel" />
        </div>
      </div>
      <div class="form-group row">
        <label for="contact_Phone" class="col-sm-4 col-form-label" i18n>Contact Phone</label>
        <div class="col-sm-8">
          <input name="contact_Phone" class="form-control"
                 matInput
                 [(ngModel)]="data.customer.contact_Phone" #contact_Phone="ngModel" />
        </div>
      </div>
      <div class="form-group row">
        <label for="contact_Mobile" class="col-sm-4 col-form-label" i18n>Contact Mobile</label>
        <div class="col-sm-8">
          <input name="contact_Mobile" class="form-control"
                 matInput
                 [(ngModel)]="data.customer.contact_Mobile" #contact_Mobile="ngModel" />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-4">
          <label for="office_ID" class="col-form-label" i18n>Office</label>
          <h5 *ngIf="!data.customer.office_ID">*Imported: {{data.customer.office_Name}}</h5>
        </div>
        <div class="col-sm-8">
          <select name="office_ID" class="form-control select-bidit"
                  [(ngModel)]="data.customer.office_ID" #office_ID="ngModel">
            <option *ngFor="let office of data.offices" [ngValue]="office.office_ID">{{office.office_Name}}</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-4">
          <label for="office_ID" class="col-form-label" i18n>Customer Type</label>
          <h5 *ngIf="!data.customer.customerType_ID">*Imported: {{data.customer.customerType_Name}}</h5>
        </div>
        <div class="col-sm-8">
          <select name="customerType_ID" class="form-control select-bidit"
                  [(ngModel)]="data.customer.customerType_ID" #customerType_ID="ngModel">
            <option *ngFor="let customerType of data.customerTypes" [ngValue]="customerType.customerType_ID">{{customerType.customerType_Desc}}</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-4">
          <label for="paymentTerm_ID" class="col-form-label" i18n>Payment Term</label>
          <h5 *ngIf="!data.customer.paymentTerm_ID">*Imported: {{data.customer.paymentTerm_Name}}</h5>
        </div>
        <div class="col-sm-8">
          <select name="paymentTerm_ID" class="form-control select-bidit"
                  [(ngModel)]="data.customer.paymentTerm_ID" #paymentTerm_ID="ngModel">
            <option *ngFor="let paymentTerm of data.paymentTerms" [ngValue]="paymentTerm.paymentTerm_ID">{{paymentTerm.paymentTerm_Desc}}</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-4">
          <label for="paymentType_ID" class="col-form-label" i18n>Payment Type</label>
          <h5 *ngIf="!data.customer.paymentType_ID">*Imported: {{data.customer.paymentType_Name}}</h5>
        </div>
        <div class="col-sm-8">
          <select name="paymentType_ID" class="form-control select-bidit"
                  [(ngModel)]="data.customer.paymentType_ID" #paymentType_ID="ngModel">
            <option *ngFor="let paymentType of data.paymentTypes" [ngValue]="paymentType.paymentType_ID">{{paymentType.paymentType_Desc}}</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-4">
          <label for="customer_assignedTo" class="col-form-label" i18n>Assigned To</label>
          <h5 *ngIf="!data.customer.customer_AssignedTo">*Imported: {{data.customer.assignedTo_FirstName}} {{data.customer.assignedTo_LastName}}</h5>
        </div>
        <div class="col-sm-8">
          <select name="customer_AssignedTo" class="form-control select-bidit"
                  [(ngModel)]="data.customer.customer_AssignedTo" #customer_AssignedTo="ngModel">
            <option *ngFor="let salesperson of data.salespersons" [ngValue]="salesperson.id">{{salesperson.firstName}} {{salesperson.lastName}}</option>
          </select>
        </div>
      </div>

      <div *ngIf="!isRequesting" class="row">
        <div class="col-sm-9">
          <button type="submit" mat-button class="mr-2 btn btn-bidit-submit" i18n>Submit</button>
          <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
        </div>
      </div>
      <div class="row" *ngIf="isRequesting">
        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </div>
      <div [hidden]="!importForm.submitted || importForm.valid"
           class="mt-3 alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
    </form>
  </div>
</div>
